import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as $ from 'jquery';
import { StorageService } from './../../../services/storage/storage.service';
import { ConfigService } from './../../../services/config/config.service';
import { UserData, SYSTEMCATEGORY } from './../../../services/auth/auth.service';
import {
  CREATE_NEW_PAGE_TYPE,
  HeaderSettings,
  PredefinedTemplatesService,
} from '../../../services/edit/predefined-templates.service';
import {
  FullRecordOptions,
  OpacSettingsService,
} from './../../../services/opac-settings/opac-settings.service';
import { SharedService } from '../../../services/shared/shared.service';
import { EditSidenavService } from './edit-sidenav.service';
import { ColorsService } from './../../../services/colors/colors.service';
import { from, Subject } from 'rxjs';
import { AdvancedSearchService } from './../../../pages/advancedsearch/advancedsearch.service';
import { MediumEditorSharedComponent } from './medium-editor-shared/medium-editor-shared.component';
import { ANIMATION_MODULE_TYPE } from '@angular/platform-browser/animations';
import { phoneNumberValidator } from './phone-validator';
import { LibraryService } from '../../../services/library/library.service';
import { switchMap, takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
  selector: 'ag-edit-sidenav',
  templateUrl: './edit-sidenav.component.html',
  styleUrls: ['./edit-sidenav.component.scss'],
  providers: [{ provide: ANIMATION_MODULE_TYPE, useValue: 'BrowserAnimations' }],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EditSidenavComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('medEditorWebLink') medEditorWebLink: MediumEditorSharedComponent;
  @Input() trigger: any;

  activePages: any;
  inactivePages: any;
  pagesSaving: boolean;
  pagesSaved: boolean;
  isOnlyCustomerCareInactivePage: boolean;
  areAllWidgetPages: boolean;
  doWidgetPagesExist: boolean;
  pageType: CREATE_NEW_PAGE_TYPE;
  showSaveApply: boolean;
  //
  // Navigation Variables
  //
  pageStart = true;
  editPage: boolean;
  login: boolean;
  search: boolean;
  record: boolean;
  pages: boolean;
  pagesCreate: boolean;
  staff: boolean;
  facet: boolean;
  zeroResults: boolean;
  briefRecordDisplayProfile: boolean;
  briefRecordSaving: boolean;
  briefRecordSaved: boolean;
  loginFormOpt: boolean;
  loginRes: boolean;
  currentAS: boolean;
  newAS: boolean;

  // Design navigation.
  design: boolean;
  header: boolean;
  style: boolean;
  colorPalette: any = {};
  themesArray: any = [];

  // Pages -- Create or Edit.
  stafftabsLocal: any = [];
  stafftabsGlobal: any = [];
  webLinkTabLabel = '';
  webLinkPageText = '';
  showBrowseIndexesPatronGuests: boolean;
  showBrowseIndexesStaff: boolean;
  canRender = true;
  private _cid: string;
  private _lid: string;
  private _destroyed$: Subject<void> = new Subject<void>();

  //
  // SECTION VARIABLES
  //

  // Header Variables
  branding: 'libOnly' | 'imageOnly' | 'customText' | 'bothImageText' = 'libOnly';
  selectedFile: File = null;
  imageNtext: boolean;
  libTitle = true;
  logoUrl = '';
  showLogo: boolean;
  logoRedirectURL = '';
  logoImageURL: string;
  logoCustomText = '';
  logoRedirectTITLE = '';
  loginButtonText = 'Login';
  showLanguages: boolean;
  showLanguagesValueBeforeModify: boolean;
  uri = this._configService.expressApi + '/file/upload';
  isUploading = false;

  // Search Varialbes.
  browse: boolean;
  advanced: boolean;
  detail: boolean;
  facets: boolean;
  results: boolean;
  simple: boolean;

  // API data
  loginOptions: any;
  facetOptions: any;
  facetsForPatronGuest: any;
  facetsForStaff: any;
  facetSaving: boolean;
  facetSaved: boolean;
  fullRecordOptions: FullRecordOptions;
  resultOptions: any;
  searchOptions: any;
  simpleSearchOptions: any;
  webLinkOptions: any;
  advSearchOptions: any;
  advSearchQualiferOptPatronGuest: any;
  advSearchQualiferOptStaff: any;
  advSearchSaving: boolean;
  advSearchSaved: boolean;
  librariesDisplayOptions: any;
  staffTabOptions: any;
  staffSaving: boolean;
  staffSaved: boolean;
  globalStaffTabReadOnlyFlag: any = true;
  maxValueofString: any = [];
  resultViewPatronGuestDefault: any;
  resultViewStaffDefault: any;
  printOptionPatronGuestDefault: any;
  printOptionStaffDefault: any;
  jacketArtListPatronGuestDefault: any;
  jacketArtListStaffDefault: any;
  resultsGroupingPatronGuest: string;
  resultsGroupingStaff: string;
  resultsSortPatronGuest: any;
  resultsSortStaff: any;
  formatSequence: any = 1;
  seeMoreFromPatronGuest: string;
  seeMoreFromStaff: string;
  showingResultsForPatronGuest: string;
  showingResultsForStaff: string;
  includeTitlesWithoutRequestableHoldingsPatronGuest: string;
  includeTitlesWithoutRequestableHoldingsStaff: string;
  enableSeachHighlightPatronsGuests: any;
  enableSeachHighlightStaff: any;
  showResultTypesPatronsGuests: any;
  showResultTypesStaff: any;
  showEformatsPatronGuests: any;
  showEformatsStaff: any;
  showResourceDetailsDisplayPatronGuests: any;
  showResourceDetailsDisplayStaff: any;

  // check for staff users
  libraryPage: any;

  briefRecordDisplayData: any;
  showBriefRecordDisplayProfileForm: boolean;
  editRDPFlag: boolean;
  editPosition = -1;

  newRdpForm: UntypedFormGroup;
  currentRdpForm: UntypedFormGroup;
  // https://stackoverflow.com/questions/19619428/html5-form-validation-pattern-alphanumeric-with-spaces
  subFieldsPattern = '[a-z0-9s]+'; // alpha - numeric
  // https://stackoverflow.com/questions/36064251/html5-form-validation-pattern
  labelPattern = '[-,@–.;/\x27:()#a-zA-Z0-9 ]*'; // any combination
  placeHolderWL = 'Enter Page Text';
  isShareIt: boolean;
  isVersoCill: boolean;
  isActiveCustomerCarePage = true;
  showFooterOptions: boolean;
  userData: UserData;

  constructor(
    private _fb: UntypedFormBuilder,
    private _advancedSearchService: AdvancedSearchService,
    private _colorsService: ColorsService,
    private _sharedService: SharedService,
    private _opacSettingsService: OpacSettingsService,
    private _libraryService: LibraryService,
    private _router: Router,
    private _snackBar: MatSnackBar,
    private _templateService: PredefinedTemplatesService,
    private _configService: ConfigService,
    public storageService: StorageService,
    private _el: ElementRef,
    private _editSidenavService: EditSidenavService,
    private _http: HttpClient,
  ) {
    if (this.storageService.has('cid')) {
      this._cid = this.storageService.getCid();
    }
    this.newRdpForm = this._fb.group({
      tagId: ['', [Validators.required, phoneNumberValidator, Validators.maxLength(3)]],
      subfields: ['', [Validators.required, Validators.pattern(this.subFieldsPattern)]],
      label: [
        '',
        [Validators.required, Validators.pattern(this.labelPattern), Validators.maxLength(20)],
      ],
    });

    this.currentRdpForm = this._fb.group({
      id: [''],
      tagId: [''],
      subfields: [''],
      label: [
        '',
        [Validators.required, Validators.pattern(this.labelPattern), Validators.maxLength(20)],
      ],
    });

    this._templateService.activePages$.pipe(takeUntil(this._destroyed$)).subscribe((response) => {
      this.activePages = response;
    });

    this._templateService.inactivePages$.pipe(takeUntil(this._destroyed$)).subscribe((response) => {
      this.inactivePages = response;

      this.isOnlyCustomerCareInactivePage =
        this.inactivePages?.length === 1 &&
        this.inactivePages[0]?.guid === 'thisIsACustomerCarePage';
      const inActivePagesWithoutCustomerCarePage = this.inactivePages?.filter(
        (x) => x.guid != 'thisIsACustomerCarePage',
      );
      const widgetPages = inActivePagesWithoutCustomerCarePage?.length
        ? inActivePagesWithoutCustomerCarePage.filter((x) => x.widgetPage === true)
        : [];
      if (widgetPages?.length) {
        this.doWidgetPagesExist = true;
      }
      if (
        inActivePagesWithoutCustomerCarePage?.length &&
        !this.isOnlyCustomerCareInactivePage &&
        inActivePagesWithoutCustomerCarePage?.length === widgetPages?.length
      ) {
        this.areAllWidgetPages = true;
      }
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    try {
      this.canRender = false;
      if (!this.storageService.getItem('access_Token')) {
        throw 'missing access token';
      }
      this._cid = this.storageService.getCid();
      this._lid = this.storageService.getLid();

      this._setComponentDefaults();
      this.goStart();
      this._getLayoutSettings();
      await this._templateService.getLibAndBindInfoAsync(this._cid, this._lid);

      if (this.userData.isStaff) {
        this._getUxSideNavSettingsAndDoBindings();
        this.isActiveCustomerCarePage =
          this._templateService?.getCustomerCarePageBSValue()?.showStaff;
      } else {
        this._getuxSideNavSettingsInterval();
      }

      if (changes.trigger) {
        this.trigger = changes.trigger.currentValue;
      }

      if (this.trigger) {
        this.showFooterOptions =
          this.userData.isCustSuperUser || (!this.isShareIt && this.userData.isLibSuperUser);
      }
    } catch (error) {
      console.error(`edit-sidenav.ts ngOnChanges error : ${error}`);
      throw new Error(error);
    }
  }

  ngOnInit() {
    this.userData = this._sharedService.userData;
    this.isShareIt = this._sharedService.systemCategory === SYSTEMCATEGORY.SHAREIT;
    this.isVersoCill =
      this._sharedService.systemCategory === SYSTEMCATEGORY.VERSO &&
      !!this.userData.illOptions?.hasILL;
    this._cid = this.storageService.getCid();
    this._lid = this.storageService.getLid();

    // reset color palette on logout
    this._colorsService
      .getColorPalleteBS()
      .pipe(takeUntil(this._destroyed$))
      .subscribe((flag) => {
        if (flag) {
          this.colorPalette = {};
        }
      });
  }

  ngOnDestroy(): void {
    this.canRender = true;
    this._colorsService.setColorDefaultsBS(null);
    this._colorsService.setColorPalleteBS(null);
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  dropAdvSearchQualifer(event: CdkDragDrop<string[]>, advSearchQualifer: any[]): void {
    moveItemInArray(advSearchQualifer, event.previousIndex, event.currentIndex);
    this.saveAdvSearchQualiferOpt();
  }

  moveAdvSearchQualifer(array: any[], from: number, to: number): void {
    moveItemInArray(array, from, to);
    this.saveAdvSearchQualiferOpt();
  }

  dropFacets(event: CdkDragDrop<string[]>, facets: any[]): void {
    moveItemInArray(facets, event.previousIndex, event.currentIndex);
    this.saveFacetOptions();
  }

  moveFacet(array: any[], from: number, to: number): void {
    moveItemInArray(array, from, to);
    this.saveFacetOptions();
  }

  dropBriefRecordDisplayField(event: CdkDragDrop<string[]>, briefRecordDisplayData: any[]): void {
    moveItemInArray(briefRecordDisplayData, event.previousIndex, event.currentIndex);
    this._saveBriefRecordDisplayField();
  }

  moveBriefRecordDisplayField(from: number, to: number): void {
    moveItemInArray(this.briefRecordDisplayData, from, to);
    this._saveBriefRecordDisplayField();
  }

  private _saveBriefRecordDisplayField(): void {
    this.briefRecordSaving = true;
    this.briefRecordSaved = false;
    this._editSidenavService.updateNewRDP(this.briefRecordDisplayData).subscribe({
      next: (response) => {
        if (response.status === '200 OK') {
          this.briefRecordDisplayData = response.data;
        }
        this.briefRecordSaving = false;
        this.briefRecordSaved = true;
        setTimeout(() => {
          this.briefRecordSaved = false;
        }, 2000);
      },
      error: () => {
        this.briefRecordSaving = false;
        this._sharedService.openSnackBar('Failed to save brief record display profile', 'ok', 4000);
      },
    });
  }

  dropActivePages(event: CdkDragDrop<string[]>, activePages: any[]): void {
    moveItemInArray(activePages, event.previousIndex, event.currentIndex);
    if (activePages[0].linkPage && activePages[0].redirectUrl) {
      moveItemInArray(activePages, event.currentIndex, event.previousIndex);
      this._sharedService.openSnackBar('link page cannot be home page');
      return;
    }
    this._saveActivePageOrder();
  }

  moveActivePage(from: number, to: number): void {
    moveItemInArray(this.activePages, from, to);
    if (this.activePages[0].linkPage && this.activePages[0].redirectUrl) {
      moveItemInArray(this.activePages, to, from);
      this._sharedService.openSnackBar('link page cannot be home page');
      return;
    }
    this._saveActivePageOrder();
  }

  private _saveActivePageOrder(): void {
    this.pagesSaving = true;
    this.pagesSaved = false;
    const postBody = {
      cid: this._cid,
      lid: this._lid,
      libId: this.storageService.getItem('libId'),
      array: this.activePages.map((element, index) => {
        element.order = index + 1;
        return element;
      }),
    };
    this._templateService.setOrderActivePages(postBody).subscribe({
      next: () => {
        this.pagesSaving = false;
        this.pagesSaved = true;
        setTimeout(() => {
          this.pagesSaved = false;
        }, 2000);
      },
      error: () => {
        this.pagesSaving = false;
        this._sharedService.openSnackBar('Failed to save page order', 'ok', 4000);
      },
    });
  }

  dropStaffLocalTabs(event: CdkDragDrop<any[]>): void {
    moveItemInArray(this.stafftabsLocal, event.previousIndex, event.currentIndex);
    this._saveStaffLocalTabs();
  }

  moveStaffLocalTab(from: number, to: number): void {
    moveItemInArray(this.stafftabsLocal, from, to);
    this._saveStaffLocalTabs();
  }

  private _saveStaffLocalTabs(): void {
    this.staffSaving = true;
    this.staffSaved = false;
    this._opacSettingsService.updateStaffLocalTabs(this.stafftabsLocal).subscribe({
      next: () => {
        this.staffSaving = false;
        this.staffSaved = true;
        setTimeout(() => {
          this.staffSaved = false;
        }, 2000);
      },
      error: () => {
        this.staffSaving = false;
        this._sharedService.openSnackBar('Failed to save staff tab order', 'ok', 4000);
      },
    });
  }

  dropStaffGlobalTabs(event: CdkDragDrop<any[]>): void {
    moveItemInArray(this.stafftabsGlobal, event.previousIndex, event.currentIndex);
    this._saveStaffGlobalTabs();
  }

  moveStaffGlobalTab(from: number, to: number): void {
    moveItemInArray(this.stafftabsGlobal, from, to);
    this._saveStaffGlobalTabs();
  }

  private _saveStaffGlobalTabs(): void {
    this.staffSaving = true;
    this.staffSaved = false;
    this._opacSettingsService.updateStaffGlobalTabs(this.stafftabsGlobal).subscribe({
      next: () => {
        this.staffSaving = false;
        this.staffSaved = true;
        setTimeout(() => {
          this.staffSaved = false;
        }, 2000);
      },
      error: () => {
        this.staffSaving = false;
        this._sharedService.openSnackBar('Failed to save staff tab order', 'ok', 4000);
      },
    });
  }

  private _setComponentDefaults(): void {
    this.loginOptions = undefined;
    this.facetOptions = undefined;
    this.facetsForPatronGuest = undefined;
    this.facetsForStaff = undefined;
    this.fullRecordOptions = undefined;
    this.resultOptions = undefined;
    this.searchOptions = undefined;
    this.simpleSearchOptions = undefined;
    this.webLinkOptions = undefined;
    this.advSearchOptions = undefined;
    this.advSearchQualiferOptPatronGuest = undefined;
    this.advSearchQualiferOptStaff = undefined;
    this.librariesDisplayOptions = undefined;
  }

  private _getuxSideNavSettingsInterval(): void {
    // check in interval to see if basicUserInfo is recieved from api.
    let counter = 0;
    const interval = setInterval(() => {
      if (this.advSearchQualiferOptPatronGuest || this.advSearchQualiferOptStaff) {
        if (interval) {
          clearInterval(interval);
        }
      }
      if (counter < 4) {
        if (!this.advSearchQualiferOptPatronGuest && !this.advSearchQualiferOptStaff) {
          this._getUxSideNavSettingsAndDoBindings();
          if (interval) {
            clearInterval(interval);
          }
        }
      } else {
        if (interval) {
          clearInterval(interval);
        }
        throw new Error('Unable to get getuxSideNavSettings');
      }
      counter += 1;
    }, 700);
  }

  private _advSearchFiltersBindings(advSearchFiltersOptions): void {
    this.advSearchQualiferOptPatronGuest = advSearchFiltersOptions.forPatronGuest;
    this.advSearchQualiferOptStaff = advSearchFiltersOptions.forStaff;
  }

  private _facetOptionsBindings(facetOptions): void {
    this.facetOptions = facetOptions;
    this.facetsForPatronGuest = this.facetOptions.forPatronGuest;
    this.facetsForStaff = this.facetOptions.forStaff;
  }

  private _staffTabOptionsBindings(staffTabOptions): void {
    this.staffTabOptions = staffTabOptions;
    // overwrite staff tabs existing demo values
    this.stafftabsLocal = this.staffTabOptions.localStaffMenu;
    this.stafftabsGlobal = this.staffTabOptions.globalStaffMenu;

    if (
      !this.staffTabOptions.localOrinals.allowLocal ||
      !this.staffTabOptions.localOrinals.localIsSet
    ) {
      this.globalStaffTabReadOnlyFlag = false;
    }
  }

  private _loginOptionsBindings(): void {
    this.loginOptions = this._opacSettingsService.loginConfig;
  }

  private _displayTargetsBindings(displayTargets): void {
    this.librariesDisplayOptions = displayTargets;
  }

  private _resultOptionsBindings(resultOptions): void {
    this.resultOptions = resultOptions;
    this._opacSettingsService.setResultOptionsBS(this.resultOptions);
    const resultView = this.resultOptions.resultView;
    const printOption = this.resultOptions.printOption;
    const jaListView = this.resultOptions.jacketArtOnListView;
    const resultGrouping = this.resultOptions.resultsGrouping;
    const resultsSort = this.resultOptions.resultsSort;
    const formatSequence = this.resultOptions.formatSequence;
    const searchHighlight = this.resultOptions.enableSearchHighlight;
    const resultTypes = this.resultOptions.showResultTypes;
    const eformatOption = this.resultOptions.eformatOption ?? null;
    const resourceDetailsDisplay = this.resultOptions.showResourceDetailsDisplay;
    const seeMoreFrom = this.resultOptions.seeMoreFrom;
    const showingResultsFor = this.resultOptions.showingResultsFor;
    const includeTitlesWithoutRequestableHoldings =
      this.resultOptions.includeTitlesWithoutRequestableHoldings ?? null;

    // result view defaults
    this.resultViewPatronGuestDefault = resultView.patronGuest.find((x) => x.selected).value;
    this.resultViewStaffDefault = resultView.staff.find((x) => x.selected).value;

    // print option defaults
    this.printOptionPatronGuestDefault = printOption.patronGuest.find((x) => x.selected).value;
    this.printOptionStaffDefault = printOption.staff.find((x) => x.selected).value;

    // jacket art list view values
    this.jacketArtListPatronGuestDefault = jaListView.patronGuest.find((x) => x.selected).value;
    this.jacketArtListStaffDefault = jaListView.staff.find((x) => x.selected).value;

    //results grouping values
    this.resultsGroupingPatronGuest = resultGrouping.patronGuest.find((x) => x.selected).value;
    this.resultsGroupingStaff = resultGrouping.staff.find((x) => x.selected).value;

    // results sort values
    this.resultsSortPatronGuest = resultsSort.patronGuest.find((x) => x.selected).value;
    this.resultsSortStaff = resultsSort.staff.find((x) => x.selected).value;

    // format sequence values. no patronGuest and staff in this array
    if (formatSequence.find((x) => x.selected)) {
      this.formatSequence = formatSequence.find((x) => x.selected).value;
    }

    // search highlights
    this.enableSeachHighlightPatronsGuests = searchHighlight.patronGuest.find(
      (x) => x.selected,
    ).value;
    this.enableSeachHighlightStaff = searchHighlight.staff.find((x) => x.selected).value;

    // result types
    this.showResultTypesPatronsGuests = resultTypes.patronGuest.find((x) => x.selected).value;
    this.showResultTypesStaff = resultTypes.staff.find((x) => x.selected).value;

    // eformat options
    if (eformatOption != null) {
      this.showEformatsPatronGuests = eformatOption.patronGuest.find((x) => x.selected).value;
      this.showEformatsStaff = eformatOption.staff.find((x) => x.selected).value;
    }

    // resource details
    this.showResourceDetailsDisplayPatronGuests = resourceDetailsDisplay.patronGuest.find(
      (x) => x.selected,
    ).value;
    this.showResourceDetailsDisplayStaff = resourceDetailsDisplay.staff.find(
      (x) => x.selected,
    ).value;

    // browse indexes
    this.showBrowseIndexesPatronGuests =
      this.resultOptions.showBrowseIndexesDisplay.patronGuest.find((x) => x.selected).value;
    this.showBrowseIndexesStaff = this.resultOptions.showBrowseIndexesDisplay.staff.find(
      (x) => x.selected,
    ).value;

    // display see more from
    this.seeMoreFromPatronGuest = seeMoreFrom.patronGuest.find((x) => x.selected).value;
    this.seeMoreFromStaff = seeMoreFrom.staff.find((x) => x.selected).value;

    // display showing results for
    this.showingResultsForPatronGuest = showingResultsFor.patronGuest.find((x) => x.selected).value;
    this.showingResultsForStaff = showingResultsFor.staff.find((x) => x.selected).value;

    // display titles without requestable holdings
    if (includeTitlesWithoutRequestableHoldings != null) {
      this.includeTitlesWithoutRequestableHoldingsPatronGuest =
        includeTitlesWithoutRequestableHoldings.patronGuest.find((x) => x.selected).value;
      this.includeTitlesWithoutRequestableHoldingsStaff =
        includeTitlesWithoutRequestableHoldings.staff.find((x) => x.selected).value;
    }
  }

  private _searchOptionsBindings(searchOptions): void {
    this.searchOptions = searchOptions;
    this._opacSettingsService.setSearchOptionsBS(this.searchOptions);
    this.simpleSearchOptions = this.searchOptions.simple;
    this.advSearchOptions = this.searchOptions.advance;
  }

  private _webLinkOptionsBindings(webLinkOptions): void {
    this.webLinkOptions = webLinkOptions;
    this.webLinkPageText = this.webLinkOptions.webLinkPageText;
    this.webLinkTabLabel = this.webLinkOptions.webLinkTabLabel;
  }

  private _getUxSideNavSettingsAndDoBindings(): void {
    this._opacSettingsService
      .getOpacSettingsObservable()
      .pipe(takeUntil(this._destroyed$))
      .subscribe((settings) => {
        if (!settings) {
          console.error('opac settings are null');
          return;
        }
        if (settings.asFiltersOptions) {
          this._advSearchFiltersBindings(settings.asFiltersOptions);
        }
        if (settings.facetOptions) {
          this._facetOptionsBindings(settings.facetOptions);
        }
        if (settings.staffTabOptions) {
          this._staffTabOptionsBindings(settings.staffTabOptions);
        }
        this._loginOptionsBindings();

        if (settings.displayTargets) {
          this._displayTargetsBindings(settings.displayTargets);
        }
        this.fullRecordOptions = settings.fullRecordOptions;
        if (settings.resultOptions) {
          this._resultOptionsBindings(settings.resultOptions);
        }
        if (settings.searchOptions) {
          this._searchOptionsBindings(settings.searchOptions);
        }
        if (settings.webLinkOptions) {
          this._webLinkOptionsBindings(settings.webLinkOptions);
        }
        this.canRender = true;
      });
  }

  private async _getLayoutSettings() {
    const layoutSettings = await this._templateService.getLayoutSettingsAsync(this._cid, this._lid);

    if (!layoutSettings) {
      return;
    }

    this.libTitle = layoutSettings.showTitle;
    this.showLogo = layoutSettings.showLogo;

    if (this.showLogo) {
      this.logoRedirectURL = layoutSettings.logoRedirectURL;
      this.logoImageURL = layoutSettings.logoImageURL;
    }
    if (layoutSettings.styles?.length > 0) {
      this.colorPalette = layoutSettings.styles;
    }
    if (layoutSettings.themes?.length > 0) {
      this.themesArray = layoutSettings.themes;
    }
  }

  updateFullRecordOptions(fullRecordOptions: FullRecordOptions): void {
    this.fullRecordOptions = fullRecordOptions;
  }

  updateThemesArray(themes) {
    this.themesArray = themes;
    this.showSaveApply = false;
  }

  updateColorsArray(colors) {
    this.colorPalette = colors;
    this.showSaveApply = true;
  }

  // ------------------------ display libraries on login logic -------------------------

  onchangeDisplayLibrariesOption(event, libKey, type) {
    const element = this.librariesDisplayOptions.find((item) => item.libraryProfileKey === libKey);
    if (element) {
      if (type === 'login') {
        element.suppressFromLoginDisplay = !event.target.checked;
      } else {
        element.suppressFromILLSearch = !event.target.checked;
      }
    }
  }

  saveDisplayLibraries() {
    this._opacSettingsService
      .setDisplayTargets(this.librariesDisplayOptions)
      .subscribe((response) => {
        if (response.status === '200 OK') {
          this._sharedService.openSnackBar(response.message);
          this.librariesDisplayOptions = response.data;
          // update the cache to get new libraries for libraries dropdown by making a new api call to get libraries
          setTimeout(() => {
            this._libraryList();
          }, 500);
        }
      });
  }

  private _libraryList() {
    const EXPIREKEY = '_' + this._cid.toUpperCase();
    const GETLIBKEY = this._cid.toUpperCase() + '_Lib';
    if (this._cid) {
      this._libraryService.getLibraries().subscribe((libraries) => {
        localStorage[EXPIREKEY] = Date.now();
        localStorage[GETLIBKEY] = JSON.stringify(libraries);
      });
    }
  }

  private _updateNewRDPApi(data) {
    // call the update api
    this._editSidenavService.updateNewRDP(data).subscribe((response) => {
      if (response.status === '200 OK') {
        this._sharedService.openSnackBar(response.message);
        this.briefRecordDisplayData = response.data;
        this.showBriefRecordDisplayProfileForm = false;
        this.briefRecordDisplayProfile = true;
      }
    });
  }

  validNewBriefRecordDisplayForm(form) {
    const formData = form.value;

    if (this.editRDPFlag && this.editPosition > -1) {
      this.briefRecordDisplayData[this.editPosition] = formData;
    } else if (this.editPosition === -1) {
      this.briefRecordDisplayData.push(formData);
    }

    this._updateNewRDPApi(this.briefRecordDisplayData);
  }

  addBriefRecordDisplayField() {
    this.newRdpForm.setValue({
      tagId: '',
      subfields: '',
      label: '',
    });
    this.editPosition = -1;
    this.showBriefRecordDisplayProfileForm = true;
    this.briefRecordDisplayProfile = false;
  }

  editBriefRecordDisplayProfile(rdp, position) {
    this.editPosition = position;
    this.editRDPFlag = false;
    if (rdp) {
      this.editRDPFlag = true;
      this.newRdpForm.setValue({
        tagId: rdp.tagId,
        subfields: rdp.subfields,
        label: rdp.label,
      });
    }
    setTimeout(() => {
      this.briefRecordDisplayProfile = false;
      this.showBriefRecordDisplayProfileForm = true;
    }, 500);
  }

  deleteBriefRecordDisplayProfile(position) {
    this._snackBar
      .open('Are you sure? ', 'Yes', {
        duration: 5000,
        verticalPosition: 'top',
      })
      .onAction()
      .subscribe(() => {
        this.briefRecordDisplayData.splice(position, 1);
        this._updateNewRDPApi(this.briefRecordDisplayData);
      });
  }

  saveAdvSearchQualiferOpt(): void {
    this.advSearchSaving = true;
    this.advSearchSaved = false;
    const postBody = {
      forPatronGuest: this.advSearchQualiferOptPatronGuest,
      forStaff: this.advSearchQualiferOptStaff,
    };
    this._opacSettingsService.updateAdvSearchFilterOptions(postBody).subscribe({
      next: async (response) => {
        if (response.status === '200 OK') {
          this.advSearchQualiferOptPatronGuest = response.data.forPatronGuest;
          this.advSearchQualiferOptStaff = response.data.forStaff;
          await this._advancedSearchService.getDefaultAvailableFiltersAsync();
        }
        this.advSearchSaving = false;
        this.advSearchSaved = true;
        setTimeout(() => {
          this.advSearchSaved = false;
        }, 2000);
      },
      error: () => {
        this.advSearchSaving = false;
        this._sharedService.openSnackBar('Failed to save advanced search qualifiers', 'ok', 4000);
      },
    });
  }

  saveFacetOptions(): void {
    this.facetSaving = true;
    this.facetSaved = false;
    const postBody = {
      forPatronGuest: this.facetsForPatronGuest,
      forStaff: this.facetsForStaff,
    };
    this._opacSettingsService.updateFacetOptions(postBody).subscribe({
      next: (response) => {
        if (response.status === '200 OK') {
          this.facetOptions = response.data;
          this.facetsForPatronGuest = response.data.forPatronGuest;
          this.facetsForStaff = response.data.forStaff;
        }
        this.facetSaving = false;
        this.facetSaved = true;
        setTimeout(() => {
          this.facetSaved = false;
        }, 2000);
      },
      error: () => {
        this.facetSaving = false;
        this._sharedService.openSnackBar('Failed to save facet options', 'ok', 4000);
      },
    });
  }

  // --------------------------------------------------------------------------------------------------------------------------
  // ------------------------------------------------ PAGE LINK FUNCTIONALITIES -----------------------------------------------
  // ---------------------------------------------------------------------------------------------------------------------------

  deletePage(list, index) {
    const isGlobal = list.isGlobal;

    // check the user flag after james fixes the getBasic user endpoint
    if (isGlobal && !this.userData.isCustSuperUser) {
      this._sharedService.openSnackBar('You are not authorized to delete this page.');
      return;
    }

    const confirmationMessage = isGlobal
      ? 'You are about to delete a global page. Are you sure?'
      : 'Are you sure?';

    this._snackBar
      .open(confirmationMessage, 'Yes', {
        duration: 5000,
        verticalPosition: 'top',
      })
      .onAction()
      .subscribe(() => {
        if (isGlobal) {
          this._deletePageInBulk(list);
        } else {
          this._deleteLocalPage(list, index);
        }
      });
  }

  private _deleteLocalPage(list, index) {
    if (!list.isGlobal && list.globalPublishArr.length === 0) {
      const body = {
        cid: this._cid,
        lid: this._lid,
        libId: this.storageService.getItem('libId'),
        pageId: list._id,
        num: list.order,
      };

      this._templateService.deletePageById(body).subscribe((response) => {
        const result: any = response;
        if (result.status === '200 OK') {
          this._sharedService.openSnackBar(result.message);
        } else {
          this._sharedService.openSnackBar('Page not found for deletion');
          this._templateService.getLibAndBindInfoAsync(this._cid, this._lid);
        }
        if (index === 0 || index === 1) {
          window.location.reload();
        }
      });
    }
  }

  private async _deletePageInBulk(list) {
    try {
      const totalLidsArr = list.totalLidsArr;
      const currentLidIndex = totalLidsArr.findIndex((x) => x.toUpperCase() === this._lid);

      if (currentLidIndex !== -1) {
        totalLidsArr.splice(currentLidIndex, 1);
        totalLidsArr.unshift(this._lid);
      }

      if (totalLidsArr.length > 0 && list.guid) {
        this.canRender = false;
        const body = {
          cid: this._cid,
          lid: this._lid,
          totalLidsArr: totalLidsArr,
          guid: list.guid,
          pageName: list.label,
        };

        const inProcessCheckResponse = await this._templateService.checkDeletePageStatusAsync(
          this._cid,
          list.guid,
        );

        if (inProcessCheckResponse && inProcessCheckResponse.message.toLowerCase() != 'all good') {
          this._sharedService.openSnackBar(inProcessCheckResponse.message);
          return;
        }

        const deleteResponse = await this._templateService.deleteAllGlobalPageASync(body);

        if (deleteResponse) {
          this._sharedService.openSnackBar(deleteResponse.message);
          setTimeout(() => {
            this._getLib4FrmExp();
          }, 3000);
        } else {
          this._sharedService.unableToCompleteRequestMessage();
        }
      } else {
        this._sharedService.openSnackBar('empty identifier and array');
      }
    } catch (error) {
      console.error(`edit-sidenav.ts:_deletePageInBulk => ${error.message}`);
    }
  }

  private _getLib4FrmExp() {
    if (this._cid && this._lid) {
      this._templateService.getLibrary(this._cid, this._lid).subscribe((response) => {
        if (response.status === '200 OK') {
          this._templateService
            .getLibraryBS()
            .pipe(takeUntil(this._destroyed$))
            .subscribe((response) => {
              if (!response) {
                return;
              }
              this.libraryPage = response.data;
              if (this.libraryPage?.[0].pages.length) {
                this.storageService.setItem('libId', this.libraryPage[0]._id);
                this.storageService.setItem('libExists', true);
              }
            });
        }
        this._sharedService.openSnackBar(response.message);
      });
    }
  }

  // -------------------------- uploading image to mongo ----------------------------------------------

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      if (file.size > 5_000_000) {
        this._sharedService.openSnackBar('Image size too large — exceeded 5MB', 'OK');
        input.value = '';
        this.selectedFile = null;
        return;
      }
      this.selectedFile = file;
    }
  }

  uploadImage() {
    if (!this.selectedFile) {
      return;
    }
    this.isUploading = true;
    const formData = new FormData();
    formData.append('photo', this.selectedFile, this.selectedFile.name);
    const params = new HttpParams();
    this._http.post(this.uri, formData, { params }).subscribe({
      next: (response: any) => {
        this._sharedService.openSnackBar('Image uploaded', null, 4000);
        this.logoImageURL = '/uploads/' + response.uploadname;
        this.selectedFile = null;
        this.isUploading = false;
        const inputEl = this._el.nativeElement.querySelector('#photo') as HTMLInputElement;
        if (inputEl) {
          inputEl.value = '';
        }
      },
      error: (error: unknown) => {
        this._sharedService.openSnackBar('Upload Image Error', null, 4000);
        console.error('Upload failed', error);
        this.isUploading = false;
      },
    });
  }

  // ------------------------------------------- Header functions --------------------------------------------

  saveHeader() {
    switch (this.branding) {
      case 'libOnly':
        this.imageNtext = false;
        this.libTitle = false;
        this.showLogo = false;
        break;
      case 'imageOnly':
        this.imageNtext = false;
        this.libTitle = false;
        this.showLogo = true;
        break;
      case 'customText':
        this.imageNtext = false;
        this.libTitle = true;
        this.showLogo = false;
        break;
      case 'bothImageText':
        this.imageNtext = true;
        this.libTitle = false;
        this.showLogo = false;
        break;
    }

    if (!this.logoImageURL && ['imageOnly', 'bothImageText'].includes(this.branding)) {
      this._sharedService.openSnackBar('Upload a logo');
      return;
    }

    const headerSettings: HeaderSettings = {
      cid: this.storageService.getCid(),
      lid: this.storageService.getLid(),
      logoImageURL: this.logoImageURL,
      logoRedirectURL: this.logoRedirectURL ? this.logoRedirectURL : '',
      showTitle: this.libTitle,
      logoAndText: this.imageNtext,
      showLogo: this.showLogo,
      name: this.logoRedirectTITLE,
      customText: this.logoCustomText,
      showLanguages: this.showLanguages,
      loginButtonText: this.loginButtonText,
    };

    if (['libOnly', 'imageOnly', 'customText', 'bothImageText'].includes(this.branding)) {
      this._saveHeader(headerSettings);
    }
  }

  // -------------------  set Header api call ---------------------------------------------
  private _saveHeader(headerSettings: HeaderSettings) {
    this._templateService.saveHeader(headerSettings).subscribe((response) => {
      if (response.status === '200 OK') {
        this._sharedService.openSnackBar(response.message, 'ok');
        // Returns the full LayoutSettings (HeaderModel) Object.
        const data = response.data[0];
        // Pass to Session for State Management / Refreshes.
        this.storageService.setItem('layoutSettings', data);
        this._sharedService.setLayoutSettings(data);
        // ------------- do all the sets again for the header ---------------------
        if (data.showLanguages) {
          window.location.reload();
        }
      }
    });
  }

  // ------------------------------------------- Stafftabs functions --------------------------------------------

  applyGlobalToLocal(): void {
    this.staffSaving = true;
    this.staffSaved = false;
    this._opacSettingsService.useGlobalOptions().subscribe({
      next: (response) => {
        if (response.status === '200 OK') {
          this.stafftabsLocal = response.data.globalStaffMenu;
        }
        this.staffSaving = false;
        this.staffSaved = true;
        setTimeout(() => {
          this.staffSaved = false;
        }, 2000);
      },
      error: () => {
        this.staffSaving = false;
        this._sharedService.openSnackBar('Failed to copy global tab order to local', 'ok', 4000);
      },
    });
  }

  applyLocalToGlobal(): void {
    this.staffSaving = true;
    this.staffSaved = false;
    this._opacSettingsService.updateStaffGlobalTabs(this.stafftabsLocal).subscribe({
      next: () => {
        this.stafftabsGlobal = [...this.stafftabsLocal];
        this.staffSaving = false;
        this.staffSaved = true;
        setTimeout(() => {
          this.staffSaved = false;
        }, 2000);
      },
      error: () => {
        this.staffSaving = false;
        this._sharedService.openSnackBar('Failed to copy local tab order to global', 'ok', 4000);
      },
    });
  }

  // ----------------------- web links form submit -------------------------------------
  saveWebLinksOptions(form) {
    const info = form.value;
    const data = {
      weblinkOnSeparateTab: {
        guest: JSON.parse(info.weblinkOnSeparateTabGuest),
        patron: JSON.parse(info.weblinkOnSeparateTabPatron),
        staff: JSON.parse(info.weblinkOnSeparateTabStaff),
      },
      weblinkOnChooseResourceScreen: {
        guest: JSON.parse(info.weblinkOnChooseResourceScreenGuest),
        patron: JSON.parse(info.weblinkOnChooseResourceScreenPatron),
        staff: JSON.parse(info.weblinkOnChooseResourceScreenStaff),
      },
      webLinkTabLabel: this.webLinkTabLabel,
      webLinkPageText: this.medEditorWebLink.getInnerText(),
    };

    this._opacSettingsService.updateWebLinksOptions(data).subscribe((response) => {
      this._sharedService.openSnackBar(response.message);
    });
  }

  // -------------- login options form submit -------------------------------------
  saveLoginOptions(form) {
    this.maxValueofString = [];
    const emailText = form.value.emailText;
    const loginInstructionalText = form.value.loginInstructionalText;
    const userNameLabel = form.value.userNameLabel;
    const passwordLabel = form.value.passwordLabel;
    const showLibraryLookupBox = form.value.showLibraryLookupBox;
    const showPasswordPrompt = form.value.showPasswordPrompt;
    const requireLoginBeforSearch = form.value.requireLoginBeforSearch;
    const redirectToAdvancedSearch = form.value.redirectToAdvancedSearch;
    const showForgotPasswordLink = form.value.showForgotPasswordLink;
    if (emailText.length > 240) {
      this.maxValueofString.push('Email');
    }
    if (loginInstructionalText.length > 240) {
      this.maxValueofString.push('Login Instructions');
    }
    if (userNameLabel.length > 50) {
      this.maxValueofString.push('user name');
    }
    if (passwordLabel.length > 50) {
      this.maxValueofString.push('password');
    }
    if (this.maxValueofString.length > 0) {
      this.maxValueofString.push('exceeded length');
      this._sharedService.openSnackBar(this.maxValueofString);
    } else {
      const body = {
        loginInstructionalText: loginInstructionalText,
        userNameLabel: userNameLabel,
        passwordLabel: passwordLabel,
        showLibraryLookupBox: showLibraryLookupBox,
        showPasswordPrompt: showPasswordPrompt,
        requireLoginBeforSearch: requireLoginBeforSearch,
        redirectToAdvancedSearch: redirectToAdvancedSearch,
        showForgotPasswordLink: showForgotPasswordLink,
        emailText: emailText,
      };

      this._opacSettingsService
        .updateLoginOptions(body)
        .pipe(
          switchMap((response) => {
            this._sharedService.openSnackBar(response.message);

            return this._opacSettingsService.getLoginOptions();
          }),
        )
        .subscribe();
    }
  }

  // ------------------------- Simple search form submit ------------------------------------
  saveSimpleSearchOptions(form) {
    const info = form.value;
    const data = {
      simple: {
        displayIndexSelectionForPatronsGuests: info.indexSelectionPatronGuest,
        displayIndexSelectionForStaff: info.indexSelectionStaff,
        displayResourceSelectionForPatronsGuests: info.resourcesSelectionPatronGuest,
        displayResourceSelectionForStaff: info.resourcesSelectionStaff,
        enableTypeAheadForPatronsGuests: info.typeAheadPatronGuest,
        enableTypeAheadForStaff: info.typeAheadStaff,
        searchBoxDefaultIndex: +info.searchBoxDefaultValue,
      },
      advance: this.advSearchOptions,
    };

    this._opacSettingsService.updateSearchOptions(data).subscribe((response) => {
      this._sharedService.openSnackBar(response.message);
    });
  }

  // ------------------------------------ Advanced Search form Submit -----------------------------------------------

  async saveAdvancedSearchOptions(form) {
    this.maxValueofString = [];

    // check the length requirements and then only do the submit pu request
    const filterTabLabel = form.value.filterTabLabel;
    const resourceTabLabel = form.value.resourceTabLabel;

    if (filterTabLabel.length > 20) {
      this.maxValueofString.push('Filter Tab Label exceeds maximum length allowed.');
    }

    if (resourceTabLabel.length > 20) {
      this.maxValueofString.push('Resources Tab Label exceeds maximum length allowed.');
    }

    if (this.maxValueofString.length > 0) {
      this._sharedService.openSnackBar(this.maxValueofString.join(' '));
    } else {
      const data = {
        simple: this.simpleSearchOptions,
        advance: {
          filterTabLabel: filterTabLabel,
          resourceTabLabel: resourceTabLabel,
          searchBoxDisplaySelectedOptionId: +form.value.searchBoxDisplayOptions,
          enableTypeAheadForPatronsGuests: JSON.parse(form.value.enableTypeAheadForPatronsGuests),
          enableTypeAheadForStaff: JSON.parse(form.value.enableTypeAheadForStaff),
          searchBoxOneDefaultIndex: +form.value.searchBoxOneDefaultIndex,
          searchBoxTwoDefaultIndex: +form.value.searchBoxTwoDefaultIndex,
          searchBoxThreeeDefaultIndex: +form.value.searchBoxThreeeDefaultIndex,
        },
      };

      this._opacSettingsService.updateSearchOptions(data).subscribe(async (response) => {
        this._sharedService.openSnackBar(response.message);
        await this._advancedSearchService.getDefaultAvailableFiltersAsync();
      });
    }
  }

  // ------------------------- search results option submit functions ----------------------

  saveResultOptions() {
    this._opacSettingsService
      .updateResultsOptions(this._buildResultsOptionsBody())
      .subscribe((response) => {
        this._sharedService.openSnackBar(response.message);
      });
  }

  private _buildResultsOptionsBody() {
    const result = {
      resultview: {
        patronguest: +this.resultViewPatronGuestDefault,
        staff: +this.resultViewStaffDefault,
      },
      print: {
        patronguest: JSON.parse(this.printOptionPatronGuestDefault),
        staff: JSON.parse(this.printOptionStaffDefault),
      },
      jacketartonlistview: {
        patronguest: JSON.parse(this.jacketArtListPatronGuestDefault),
        staff: JSON.parse(this.jacketArtListStaffDefault),
      },
      resultsgrouping: {
        patronguest: +this.resultsGroupingPatronGuest,
        staff: +this.resultsGroupingStaff,
      },
      resultsort: {
        patronguest: +this.resultsSortPatronGuest,
        staff: +this.resultsSortStaff,
      },
      formatsequence: +this.formatSequence,
      enablesearchhighlight: {
        patronguest: JSON.parse(this.enableSeachHighlightPatronsGuests),
        staff: JSON.parse(this.enableSeachHighlightStaff),
      },
      showresulttypes: {
        patronguest: JSON.parse(this.showResultTypesPatronsGuests),
        staff: JSON.parse(this.showResultTypesStaff),
      },
      eformatOption: {
        patronguest: JSON.parse(this.showEformatsPatronGuests),
        staff: JSON.parse(this.showEformatsStaff),
      },
      showresourcedetailsdisplay: {
        patronguest: JSON.parse(this.showResourceDetailsDisplayPatronGuests),
        staff: JSON.parse(this.showResourceDetailsDisplayStaff),
      },
      showBrowseIndexesDisplay: {
        patronguest: this.showBrowseIndexesPatronGuests,
        staff: this.showBrowseIndexesStaff,
      },
      seeMoreFrom: {
        patronguest: this.seeMoreFromPatronGuest,
        staff: this.seeMoreFromStaff,
      },
      showingResultsFor: {
        patronguest: this.showingResultsForPatronGuest,
        staff: this.showingResultsForStaff,
      },
      includeTitlesWithoutRequestableHoldings: {
        patronguest: this.includeTitlesWithoutRequestableHoldingsPatronGuest,
        staff: this.includeTitlesWithoutRequestableHoldingsStaff,
      },
    };
    return result;
  }

  // ------ SETTINGS NAvigation Variables -------------

  private _clearAll() {
    this.pageStart = false;
    this.login = false;
    this.search = false;
    this.style = false;
    this.record = false;
    this.pages = false;
    this.design = false;
    this.staff = false;
    this.pagesCreate = false;
    this.header = false;
    this.simple = false;
    this.results = false;
    this.zeroResults = false;
    this.briefRecordDisplayProfile = false;
    this.showBriefRecordDisplayProfileForm = false;
    this.detail = false;
    this.facets = false;
    this.advanced = false;
    this.currentAS = false;
    this.newAS = false;
    this.browse = false;
    this.loginFormOpt = false;
    this.loginRes = false;
  }

  goStart() {
    this._clearAll();
    this.pageStart = true;
  }

  goLoginForm() {
    this._clearAll();
    this.loginFormOpt = true;
  }

  goDisplayLibs() {
    this._clearAll();
    this.loginRes = true;
  }

  goLogin() {
    this._clearAll();
    this.login = true;
  }

  goSearch() {
    this._clearAll();
    this.search = true;
  }

  goPages() {
    this._clearAll();
    this.pages = true;
  }

  goDesign() {
    this._clearAll();
    this.design = true;
  }

  goStaff() {
    this._clearAll();
    this.staff = true;
  }

  language(event) {
    this.showLanguages = event.checked;
  }

  // ------ DESIGN NAvigation Variables -------------
  goDesignOptions() {
    this._clearAll();
    this.design = true;
  }

  goHeader() {
    // get the header and bind the vaules
    if (this._cid && this._lid) {
      const headerResponse = this._templateService.getLayoutSettingsAsync(this._cid, this._lid);
      const observable = from(headerResponse);
      observable.subscribe((response) => {
        this.libTitle = false;
        this.showLogo = false;
        this.imageNtext = false;

        if (response.showTitle) {
          this.libTitle = true;
        }
        if (response.showLogo) {
          this.showLogo = true;
          this.logoRedirectURL = response.logoRedirectURL;
          this.logoImageURL = response.logoImageURL;
        }

        const headerData = response;
        if (headerData) {
          if (headerData.showTitle) {
            this.libTitle = true;
          }
          if (headerData.showLogo) {
            this.showLogo = true;
          }
          if (headerData.logoAndText) {
            this.imageNtext = true;
          }
          if (headerData.logoRedirectURL) {
            this.logoRedirectURL = headerData.logoRedirectURL;
          }
          if (headerData.logoImageURL) {
            this.logoImageURL = headerData.logoImageURL;
          }
          if (headerData.name) {
            this.logoRedirectTITLE = headerData.name;
          }
          if (headerData.loginButtonText) {
            this.loginButtonText = headerData.loginButtonText;
          }
          if (headerData.customText) {
            this.logoCustomText = headerData.customText;
          }
          if (headerData.showLanguages) {
            this.showLanguages = headerData.showLanguages;
            this.showLanguagesValueBeforeModify = JSON.parse(JSON.stringify(this.showLanguages));
          }

          if (!this.libTitle && !this.showLogo && !this.imageNtext) {
            this.branding = 'libOnly';
          } else if (!this.libTitle && this.showLogo && !this.imageNtext) {
            this.branding = 'imageOnly';
          } else if (this.libTitle && !this.showLogo && !this.imageNtext) {
            this.branding = 'customText';
          } else if (!this.libTitle && !this.showLogo && this.imageNtext) {
            this.branding = 'bothImageText';
          }
          // show side nave after the above stuff completed
          this.pageStart = false;
          this.design = false;
          this.header = true;
        } else {
          // show side nav the way it is as no header exists in back
          this.pageStart = false;
          this.design = false;
          this.header = true;
        }
      });
    }
  }
  goStyle() {
    this._clearAll();
    this.style = true;
  }
  goFooter() {
    // check user rights.
    if (this.userData.isCustSuperUser || this.userData.isLibSuperUser) {
      this._clearAll();
      this.design = true;
      this._router.navigate(['/edit-footer'], { queryParams: { lat: true } });
      this.closeOverlay();
    } else {
      this._sharedService.openSnackBar('You are not authorized to edit footer.', 'ok');
    }
  }

  // ------ SEARCH OPTIONS NAvigation Variables -------------

  goSearchOptions() {
    this._clearAll();
    this.search = true;
  }

  goAdvanced() {
    this._clearAll();
    this.advanced = true;
  }
  goCurrentAS() {
    this._clearAll();
    this.currentAS = true;
  }
  goNewAS() {
    this._clearAll();
    this.newAS = true;
  }
  goBrowse() {
    this._clearAll();
    this.browse = true;
  }
  goDetail() {
    this._clearAll();
    this.detail = true;
  }
  goFacets() {
    this._clearAll();
    this.facets = true;
  }
  goResults() {
    this._clearAll();
    this.results = true;
  }
  goZeroResults() {
    this._clearAll();
    this.zeroResults = true;
  }
  goRDP() {
    this._clearAll();
    this.briefRecordDisplayProfile = true;
    this._editSidenavService.getNewRDP().subscribe((response) => {
      if (response.status === '200 OK') {
        this.briefRecordDisplayData = response.data;
      }
    });
  }
  goSimple() {
    this._clearAll();
    this.simple = true;
  }
  createPage() {
    this._clearAll();
    this.pagesCreate = true;
    this.pageType = CREATE_NEW_PAGE_TYPE.PAGE;
  }
  createPageLink() {
    this._clearAll();
    this.pagesCreate = true;
    this.pageType = CREATE_NEW_PAGE_TYPE.LINK;
  }
  createWidget() {
    this._clearAll();
    this.pagesCreate = true;
    this.pageType = CREATE_NEW_PAGE_TYPE.WIDGET;
  }
  editCustomPage(page, pageType: any) {
    try {
      if (page?.isGlobal && !this.userData.isCustSuperUser) {
        this._sharedService.openSnackBar('You are not authorized to edit this page.');
        return;
      }
      this._goToUpdatePageAsync(page._id, pageType);
    } catch (error) {
      console.error(`error in EditSideNavComponent.ts: editCustomPage  => ${error.message}`);
      throw new Error(error);
    }
  }

  editCustomerCarePage() {
    try {
      if (!this.userData.isCustSuperUser) {
        this._sharedService.openSnackBar('You are not authorized to edit this page.');
        return;
      }
      const customerPage = this._templateService.getCustomerCarePageBSValue();
      if (!customerPage) {
        console.error('customer care page is null');
        return;
      }
      this.storageService.setItem('editPage', customerPage);
      this._templateService.predefined.next(customerPage);

      this._router.navigate(['/home-edit'], {
        queryParams: { pageId: customerPage._id, type: CREATE_NEW_PAGE_TYPE.PAGE },
      });
    } catch (error) {
      console.error(`error in EditSideNavComponent.ts: editCustomerCarePage  => ${error}`);
    }
  }

  private async _goToUpdatePageAsync(pageId, pageType: CREATE_NEW_PAGE_TYPE): Promise<void> {
    const pageRequestPayload = {
      cid: this._cid,
      lid: this._lid,
      libId: this.storageService.getItem('libId'),
      pageId: pageId,
    };

    const response = await this._templateService.getPageByIdAsync(pageRequestPayload);

    if (!response) {
      this._sharedService.openSnackBar(`Unable to retrieve page with pageId: ${pageId}`);
      return;
    }

    if (!response?.pages[0]) {
      this._sharedService.openSnackBar('Page not found for editing');
      this._templateService.getLibAndBindInfoAsync(this._cid, this._lid);
      return;
    }

    const tempPage = {
      pageId: response.pages[0]._id,
      label: response.pages[0].label,
      newtab: response.pages[0].newtab,
      private: response.pages[0].private,
      routeLink: response.pages[0].routeLink,
      active: response.pages[0].active,
      activeDate: response.pages[0].activeDate,
      activeOnDate: response.pages[0].activeOnDate,
      showGuest: response.pages[0].showGuest,
      showPatron: response.pages[0].showPatron,
      showStaff: response.pages[0].showStaff,
      setHome: response.pages[0].setHome,
      homeOnDate: response.pages[0].homeOnDate,
      homeDate: response.pages[0].homeDate,
      linkPage: response.pages[0].linkPage,
      widgetPage: pageType === CREATE_NEW_PAGE_TYPE.WIDGET,
      redirectUrl: response.pages[0].redirectUrl,
      templates: response.pages[0].templates,
    };
    if (tempPage?.linkPage) {
      pageType = CREATE_NEW_PAGE_TYPE.LINK;
    }
    this._templateService.setNewPageLabelBS(null);

    this.storageService.setItem('editPage', tempPage); // save the page in session storage and fetch it on home-edit
    this._templateService.predefined.next(tempPage); // getter on home-edit getNewTemplate
    this.closeOverlay();
    this.storageService.setIsNewPage(false);
    this._router.navigate(['/home-edit'], { queryParams: { pageId: pageId, type: pageType } });
  }

  closeOverlay() {
    // ? commented code for hightlight link in staff menu side nav
    $('.mat-drawer-shown').click();
  }

  compareWithValue(a: any, b: any): boolean {
    return String(a) === String(b);
  }
}
